"use client";

import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface AnalyticsUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
}

export function AnalyticsUpgradeModal({ isOpen, onClose, onUpgrade }: AnalyticsUpgradeModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg border border-white/10 bg-neutral-900 p-6 shadow-xl">
        <h3 className="text-xl font-semibold text-white">
          {t('account_social.unlock_analytics_modal_title')}
        </h3>
        <p className="mt-3 text-sm text-neutral-300">
          {t('account_social.unlock_analytics_modal_description')}
        </p>
        <div className="mt-6 flex gap-3">
          <Button
            variant="outline"
            className="flex-1"
            onClick={onClose}
          >
            {t('common.close')}
          </Button>
          <Button
            variant="highlight"
            className="flex-1"
            onClick={onUpgrade}
          >
            {t('account_social.unlock_analytics_modal_cta')}
          </Button>
        </div>
      </div>
    </div>
  );
}
